// extracted by mini-css-extract-plugin
export default {"titleName":"TitleLogo_titleName__831wr","logo":"TitleLogo_logo__dLNOn","containerTitleLogo":"TitleLogo_containerTitleLogo__Sg3h7","skeleton":"TitleLogo_skeleton__EiPTW"};